import { Seo } from '@/components/Seo';
import { ContentPage } from '@/components/PublicLayout';
import { useLang, useT } from '@/i18n/LanguageContext';
import { mediaContent } from '@/i18n/content/media';
import { pathFor } from '@/i18n/routes';

interface Item {
  date: string;
  source: string;
  title: string;
  url: string;
}

const items: Item[] = [
  {
    date: '09-10-2024',
    source: 'Middenstandsbelangen.nl',
    title: '‘Kunstwerk op Strabrecht College onthult dialoog tussen mens en AI’',
    url: 'https://www.middenstandsbelangen.nl/nieuws/algemeen/48542/kunstwerk-op-strabrecht-college-onthult-dialoog-tussen-mens-en-ai',
  },
  {
    date: '12-07-2021',
    source: 'Eindhovens Dagblad',
    title: '‘MMC Veldhoven is blij met lichtkunstwerk voor zorgmedewerkers’',
    url: 'https://www.ed.nl/veldhoven/mmc-veldhoven-is-blij-met-lichtkunstwerk-voor-zorgmedewerkers-symboliseert-verbondenheid-in-coronatijd~ab408fd9/',
  },
  {
    date: '18-05-2020',
    source: 'Omroep Brabant',
    title: '‘Lichtkunst laat ziekenhuizen en bezoekers op elkaar reageren: Contact is nu iets onbetaalbaars’',
    url: 'https://www.omroepbrabant.nl/nieuws/3205807/lichtkunst-laat-ziekenhuizen-en-bezoekers-op-elkaar-reageren-contact-is-nu-iets-onbetaalbaars',
  },
  {
    date: '18-05-2020',
    source: 'Indebuurt.nl',
    title: '‘Rob brengt lichtkunst naar ziekenhuizen: Zorgpersoneel verdient een lichtpuntje’',
    url: 'https://indebuurt.nl/eindhoven/eindhovenaren/rob-brengt-lichtkunst-naar-ziekenhuizen-zorgpersoneel-verdient-een-lichtpuntje~116283/',
  },
  {
    date: '18-05-2020',
    source: 'Entertainment Business',
    title: '‘Lichtkunstenaars Glow brengen licht in Eindhovense ziekenhuizen’',
    url: 'https://www.entertainmentbusiness.nl/persberichten/lichtkunstenaars-glow-brengen-licht-in-eindhovense-ziekenhuizen/',
  },
  {
    date: '08-05-2020',
    source: 'RARA Radio',
    title: 'Interview met nachtburgemeester Siem Nozza op RARA Radio',
    url: 'https://www.behance.net/gallery/96870755/Interview-op-RaRa-Radio',
  },
  {
    date: '16-06-2016',
    source: 'Eindhovens Dagblad',
    title: '‘Plaza Futura viert 25-jarig bestaan met feest in Eindhoven met Rot8ion performance’',
    url: 'https://www.ed.nl/default/plaza-futura-viert-25-jarig-bestaan-met-feest-in-eindhoven~a15cc491/',
  },
  {
    date: '13-07-2014',
    source: 'Eindhovens Dagblad',
    title: '‘Spectaculaire eindshow Extrema Outdoor 2014 door Rot8ions Collider’',
    url: 'https://www.ed.nl/best/spectaculaire-eindshow-extrema-outdoor-2014-video~a8ed810e/',
  },
  {
    date: '13-07-2014',
    source: 'De Telegraaf',
    title: '’Extrema knalt weer als vanouds’',
    url: 'https://www.telegraaf.nl/nieuws/extrema-knalt-weer-als-vanouds/65357367.html',
  },
  {
    date: '01-07-2013',
    source: 'Emerce.nl',
    title: '‘Wereldprimeur op Extrema Outdoor’',
    url: 'https://www.emerce.nl/wire/wereldprimeur-extrema-outdoor',
  },
  {
    date: '01-07-2013',
    source: 'Festileaks.com',
    title: '‘Wereldprimeur op Extrema Outdoor’',
    url: 'https://festileaks.com/2013/07/wereldprimeur-op-extrema-outdoor/',
  },
  {
    date: '24-02-2012',
    source: 'Eindhovens Dagblad',
    title: '‘Driedimensionale voorstelling dj Martyn en kunstenaar Erosie en Rot8ions Collider’',
    url: 'https://www.ed.nl/muziek/driedimensionale-voorstelling-dj-martyn-en-kunstenaar-erosie~a0373627/',
  },
  {
    date: '29-06-2010',
    source: 'HIFI.nl',
    title: '‘Meer ruimte in muziek dankzij ‘space-jockey’’',
    url: 'https://hifi.nl/artikel/2084/Meer-ruimte-in-muziek-dankzij-space-jockey.html',
  },
];

export default function Media() {
  const lang = useLang();
  const t = useT(mediaContent);
  return (
    <>
      <Seo title={t.seoTitle} description={t.seoDescription} path={pathFor('media', lang)} />
      <ContentPage title={t.title} intro={t.intro}>
        <ul className="space-y-6">
          {items.map((item) => (
            <li key={item.url + item.date} className="border-b border-sitefg/5 pb-6">
              <div className="text-xs font-mono tracking-wider text-sitefg/40">
                {item.date} · {item.source}
              </div>
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-1 inline-block leading-relaxed text-[var(--viz-accent)] hover:underline"
              >
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </ContentPage>
    </>
  );
}
